import React from 'react';
import { MdAssignment, MdAssessment, MdSchool, MdSupervisorAccount, MdPeople, MdSettings, MdVideoLibrary, MdChat, MdImage, MdDesktopWindows, MdHistory, MdDescription, MdWarning, MdMeetingRoom, MdRecordVoiceOver, MdViewQuilt, MdSecurity, MdAutoFixHigh, MdOpenInNew, MdPrint } from 'react-icons/md';
import './SectionButtons.css';

const icons = {
  externo: MdOpenInNew, imprimir: MdPrint,
  conteudos: MdDescription, questoes: MdAssignment, modulos: MdSchool, atribuicoes: MdSupervisorAccount, ia: MdAutoFixHigh,
  relatorios: MdAssessment, processos: MdAssignment, corretores: MdDescription, fiscais: MdSecurity,
  avaliadores: MdSupervisorAccount, candidatos: MdPeople, treinamentos: MdSchool,
  configuracoes: MdSettings, redacoes: MdDescription, provas: MdAssignment,
  diagramacoes: MdViewQuilt, questionarios: MdAssignment, salas: MdMeetingRoom,
  eventos: MdWarning, entrevistas: MdRecordVoiceOver, relatorio: MdHistory,
  mensagens: MdChat, videos: MdVideoLibrary, telas: MdDesktopWindows,
  imagens: MdImage, logs: MdHistory, acoes: MdWarning,
};

const moduleIcons = { imprimir: '🖨️', externo: '🔗', conteudos: '📖', questoes: '❓', modulos: '🎓', atribuicoes: '👥', ia: '✨', relatorio: '📊', mensagens: '💬', videos: '🎥', telas: '🖥️', imagens: '🖼️', logs: '🕒', acoes: '⚠️', relatorios: '📊', processos: '📋', corretores: '👨‍🏫', fiscais: '🛡️', avaliadores: '⭐', candidatos: '👥', treinamentos: '🎓', configuracoes: '⚙️', redacoes: '📝', provas: '📚', diagramacoes: '📄', questionarios: '❓', salas: '🏢', eventos: '⚠️', entrevistas: '🎙️' };

export default function SectionButtons({ items, value, onChange, label = 'Seções', variant, compact = false }) {
  return <nav className={(`section-buttons${compact ? ' is-compact' : ''}`) + " hidethis"} aria-label={label}>
    {items.filter(item => item.visible !== false).map(item => {
      const Icon = icons[item.icon] || MdAssignment;
      const Element = item.href ? 'a' : 'button';
      return <Element key={item.value} type={item.href ? undefined : 'button'} href={item.href} target={item.href ? '_blank' : undefined} rel={item.href ? 'noopener noreferrer' : undefined} className={`section-button${value === item.value ? ' is-selected' : ''}`}
        aria-label={item.label} title={item.description} aria-pressed={item.href ? undefined : value === item.value} onClick={item.href ? undefined : () => onChange(item.value)}>
        {variant === 'modules' ? <span className="module-button-icon" aria-hidden="true">{moduleIcons[item.icon]}</span> : <Icon size={23} aria-hidden="true" />}
        <span className="section-button-text">
          <span className="section-button-name">{item.label}</span>
          {item.description && <span className="section-button-description">{item.description}</span>}
        </span>
      </Element>;
    })}
  </nav>;
}
